export type GeneratePermission = {
  MODULE: string
  PERMISION: string
  CREATE: string
  READ: string
  UPDATE: string
  DELETE: string
  SOFT_DELETE: string
}

export const generatePermission = (permission: string): GeneratePermission => {
  const module = permission.slice(0, 2)

  return {
    MODULE: module,
    PERMISION: permission,
    CREATE: `${permission}1`,
    READ: `${permission}2`,
    UPDATE: `${permission}3`,
    DELETE: `${permission}4`,
    SOFT_DELETE: `${permission}5`,
  }
}